export const LibConfig = {
    regionIds: [],
    sportIds: [],
    eventState: "Mixed",
    allRegions: new Map()
};
export const init = function (config) {
    LibConfig.regionIds = config.regionIds;
    LibConfig.sportIds = config.sportIds;
};
//# sourceMappingURL=init.js.map